import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Error from './Error';
import useMoneda from '../hooks/useMoneda';
import useCripto from '../hooks/useCripto';
import axios from 'axios';
import PropTypes from 'prop-types'


const Boton = styled.input`
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    background-color: #66a2fe;
    border: none;
    width: 100%;
    border-radius: 10px;
    color: #fff;
    transition: background-color .3s ease;

    &:hover {
        background-color: #326ac0;
        cursor: pointer;
    }

`


const Formulario = ({ guardarMoneda, guardarCripto }) => {

    //state del listado de Criptomonedas
    const [listaCripto, guardarCriptos] = useState([])

    //error
    const [ error, guardarError ] = useState(false);


    const MONEDAS = [
        {codigo: "USD", nombre: "Dolar de EEUU"},
        {codigo: "MXN", nombre: "Peso Mexicano"},
        {codigo: "EUR", nombre: "Euro"},
        {codigo: "GBP   ", nombre: "Libra Esterlina"}
    ];

    //Utilizar useMoneda
    const [ moneda, SelectMoneda ] = useMoneda("Elige tu Moneda", "", MONEDAS);

    //Utilizar useCripto
    const [ cripto, SelectCripto ] = useCripto("Elige tu Criptomoneda", "", listaCripto)

    //ejecutar llamdo a la API
    useEffect(() => {
        const consultarAPI = async () => {
            const url = "https://min-api.cryptocompare.com/data/top/mktcapfull?limit=10&tsym=USD";

            const resultado = await axios.get(url);

            guardarCriptos(resultado.data.Data);
            
        } 
        consultarAPI()
    }, [] )

    //cuando el usuario hace Submit
    const cotizarMoneda = e => {
        e.preventDefault();

        // validar si los campos estan llenos
        if (moneda === "" || cripto === "") {
            guardarError(true);
            return;
        }

        //pasar los datos al componente principal
        guardarError(false);

        guardarMoneda(moneda);
        guardarCripto(cripto);

    }

    return (

        <form
            onSubmit = {cotizarMoneda}
        >

            { error ? <Error mensaje={"Ambos campos son obligatorios"}></Error> : null }

            <SelectMoneda
                
            />

            <SelectCripto
            
            />

            <Boton
                type="submit"
                value="Calcular"
            />

        </form>

     );
}
 
Formulario.propTypes = {
    guardarMoneda: PropTypes.func.isRequired,
    guardarCripto: PropTypes.func.isRequired
}

export default Formulario;